import * as React from "react";
import { observer } from "mobx-react-lite";
import { TableStore } from "src/components/tables/TableStore";
import { Button } from "antd";
import {
  EntityFilters,
  ZEntityRow,
} from "src/pages/EntityFiltersPage/EntityList/types";
import { appStore } from "src/appStore";
import { ExportIconStd } from "src/common/icons";
import { t } from "i18next";
import styles from "./EntityExportButton.module.less";
import { createExportUrl } from "./createExportUrl";

interface PropsEntityExportButton {
  store: TableStore<ZEntityRow, EntityFilters>;
  objectName: string;
}

export const EntityExportButton: React.FC<PropsEntityExportButton> = observer(
  ({ store, objectName }) => (
    <Button
      className={styles.container}
      type="link"
      icon={<ExportIconStd />}
      download={`${objectName}.xlsx`}
      href={createExportUrl(store, appStore.curLang)}
    >
      {t("Table export")}
    </Button>
  ),
);
